import type { ChangePasswordResponse } from '@shared/schemas/account';

import api from '@/shared/api/api-client';

import type { PasswordChangeDraft } from '../domain/password-change.model';
import type { PasswordChangeGateway } from './password-change.gateway';

/**
 * Real implementation over the shared api client; the single place that knows
 * the endpoint and the snake_case body (`ChangePasswordRequestSchema` in
 * `shared/schemas/account.ts`).
 *
 * The passwords are sent verbatim: NO trimming, unlike the identity gateway
 * next door. A leading or trailing space is a legitimate character of a
 * password, and silently dropping it here would hash something the user never
 * typed; they would then fail to sign in with the password they chose.
 *
 * `api.post` already unwraps the `{ success, data }` envelope, so what lands
 * here is the `data` object.
 */
export const httpPasswordChangeGateway: PasswordChangeGateway = {
  changePassword: async (draft: PasswordChangeDraft) => {
    const data = await api.post<ChangePasswordResponse['data']>('/account/password', {
      current_password: draft.currentPassword,
      new_password: draft.newPassword,
    });
    return { revokedSessions: data.revoked_sessions };
  },
};
